import type { MessageChannel } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import {
  SupportTicketFilterNames,
  supportTicketFilterData,
} from "@redotech/effect-api-shared/schema/support-ticket-filters";
import ChannelsIcon from "@redotech/redo-icons/message-chat-circle.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import type { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

/** Channels users can filter by in the support ticket list. */
const FILTERABLE_CHANNELS: MessageChannel[] = [
  "gmail",
  "outlook",
  "instagramDm",
  "instagramComments",
  "facebookDm",
  "facebookComments",
  "tiktok",
  "attentive",
  "sms",
  "postscript",
  "redoChat",
];

/**
 * Human-readable labels for filterable channels.
 */
const FilterableChannelReadable: Record<MessageChannel, string> = {
  gmail: "Email (Gmail)",
  outlook: "Email (Outlook)",
  instagramDm: "Instagram DM",
  instagramComments: "Instagram Comments",
  facebookDm: "Facebook DM",
  facebookComments: "Facebook Comments",
  tiktok: "TikTok",
  attentive: "Attentive",
  sms: "SMS",
  postscript: "Postscript",
  redoChat: "Redo Chat",
  voice: "Voice",
  contactForm: "Contact Form",
  internalNote: "Internal Note",
  mobileMessage: "iMessage",
};

/**
 * Channels filter uses MessageChannel values to match what's stored
 * in OpenSearch and returned by the API.
 */
export const ChannelsAdvancedFilter: ArrayStringTableFilter<MessageChannel> = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  Icon: ChannelsIcon,
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  data: supportTicketFilterData[SupportTicketFilterNames.CHANNELS],
  itemLabel: "channel",
  itemLabelPlural: "channels",
  values: FILTERABLE_CHANNELS,
  display: (item: MessageChannel) => FilterableChannelReadable[item] ?? item,
  displayName: "Channels",
};
